import React from 'react';
import { Box, Button } from '@mui/material';
import { CustomLabelMediumRegular, CustomLabelMediumBold, CustomLabelSmallMedium} from "../common/CustomLabel";
import Grid from "@mui/material/Grid/Grid";
import BABEZ_LONDON from '../../assets/logos/BabezLondon.png';
import DEER_PE from '../../assets/logos/DeerPe.png';
import DUBAI_AIRPORT from '../../assets/logos/DubaiAirport.png';
import ELPAD from '../../assets/logos/ELPadel.png';
import HALAL_FLY from '../../assets/logos/HalalFly.png';
import NUNCMITTO from '../../assets/logos/Nuncmitto.png';
import PAF from '../../assets/logos/PAF.png';
import PADEL_ZOCO from '../../assets/logos/PadelZoco.png';
import SIPSKIP from '../../assets/logos/SipSkip.png';
import THE_CHECKER from '../../assets/logos/TheChecker.png';
import BOX_ICON from "../../assets/images/3d-center-box.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TrustedByIndustryLeaders = ({trustedByIndustryLeadersRef, setShowWhatService}) => {
  const companyLogos = [
    { src: BABEZ_LONDON, alt: 'Babez London' },
    { src: DEER_PE, alt: 'Deer PE' },
    { src: DUBAI_AIRPORT, alt: 'Dubai Airport' },
    { src: ELPAD, alt: 'EL Padel' },
    { src: HALAL_FLY, alt: 'Halal Fly' },
    { src: NUNCMITTO, alt: 'Nuncmitto' },
    { src: PAF, alt: 'PAF' },
    { src: PADEL_ZOCO, alt: 'Padel Zoco' },
    { src: SIPSKIP, alt: 'Sip Skip' },
    { src: THE_CHECKER, alt: 'The Checker' }
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    swipeToSlide: true,  // Enable touch swipe
    draggable: true,     // Enable mouse drag
    touchThreshold: 10,  // Make touch more sensitive
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>
      <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "30px", md: "50px"}, textAlign: "center" }}>
        <CustomLabelMediumBold text={"TRUSTED BY INDUSTRY LEADERS – CONFIDENCE BUILT ON PERFORMANCE"} fontWeight={700} color={"#5E17EB"}/>
      </Grid>
      <div ref={trustedByIndustryLeadersRef} tabIndex={0}></div>
      <Grid item container xs={10} sx={{marginTop: {xs: "2px", md: "5px"}}} justifyContent={"center"} alignItems={"center"}>
        <CustomLabelMediumRegular normal={false}
                                  text={<>
                                    From enterprise applications to scalability needs, we've partnered with various industries to deliver reliability and quality. Our experience speaks through the trust we've built in the last 7 Years in Web App Development Services, Full Project Development Services but especially in 
                                    &nbsp;<a href="https://ostryx.com" target="_blank" rel="noopener noreferrer" style={{color: "#5E17EB"}}><b>Mobile Application Development Services</b></a> 
                                    </>}
        />
      </Grid>

      <Grid item xs={12} sx={{ 
        // padding: {xs: "0px 5px", md: "0px 30px"}, 
        marginTop: "40px",
        '& .slick-track': {
          display: 'flex',
          alignItems: 'center'
        },
        '& .slick-slide': {
          cursor: 'grab',
          '&:active': {
            cursor: 'grabbing'
          }
        }
      }}>
        <Slider {...settings}>
          {[...companyLogos, ...companyLogos].map((logo, index) => (
            <Box
              key={index}
              sx={{
                px: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none', // Prevent image dragging
                WebkitUserDrag: 'none'
              }}
            >
              <Box
                component="img"
                src={logo.src}
                alt={logo.alt}
                draggable={false} // Prevent image dragging
                sx={{
                  width: '100%',
                  maxWidth: '150px',
                  height: 'auto',
                  objectFit: 'contain',
                  // filter: 'grayscale(100%)',
                  opacity: 0.7,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    filter: 'grayscale(0%)',
                    opacity: 1,
                    transform: 'scale(1.05)'
                  }
                }}
              />
            </Box>
          ))}
        </Slider>
      </Grid>

      <Grid 
        item 
        container 
        justifyContent="center"
        sx={{ mt: { xs: 3, md: 4 } }}
      >
        <Button
          onClick={setShowWhatService}
          sx={{
            border: "1.5px solid #F5F5F5",
            borderRadius: "15px",
            padding: "12px 25px",
            backgroundColor: "#5E17EB",
            '&:hover': {
              backgroundColor: "#4912b9"
            }
          }}
        >
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: '10px'
            }}
          >
            <Box
              component="img"
              src={BOX_ICON}
              alt={"Discuss Your Project"}
              sx={{
                width: { xs: '24px', md: '28px' },
                height: 'auto'
              }}
            />
            <CustomLabelSmallMedium 
              text="Discuss Your Project with Experts"
              color="white"
            />
          </Box>
        </Button>
      </Grid>
    </Grid>
  );
};

// Add these styles to your CSS
// const styles = `
//   .slick-slider {
//     touch-action: pan-y;
//     -webkit-touch-callout: none;
//     -webkit-user-select: none;
//     -khtml-user-select: none;
//     -moz-user-select: none;
//     -ms-user-select: none;
//     user-select: none;
//     -webkit-tap-highlight-color: transparent;
//   }

//   .slick-list {
//     overflow: hidden;
//   }

//   .slick-track {
//     display: flex !important;
//   }

//   .slick-slide {
//     height: auto;
//   }
// `;

export default TrustedByIndustryLeaders;